<template>
  <div>
    <!-- データ選択ダイアログ -->
    <v-dialog :value="value" @input="(v) => v || close()" max-width="400">
      <v-card>
        <v-card-title>
          <span class="headline">アノテーションコピー</span>
        </v-card-title>
        <v-card-text class="py-0 px-0">
          <v-container class="py-0" id="folderSelector">
            <h4 class="mt-1 mb-2 ml-4">コピー先を選択してください。</h4>
            <v-list class="py-0">
              <v-list-item-group
                v-model="selectedIndex"
                id="folderSelector"
                color="primary"
              >
                <v-list-item v-for="(item, i) in folders" :key="i">
                  <v-list-item-content>
                    <v-list-item-title
                        v-text="`${item.property.shooting_date ? item.property.shooting_date.split(' ')[0] : null}${item.note ? ' (' + item.note + ')' : null}`"
                    ></v-list-item-title>
                    <div>
                      <v-chip
                        v-if="item.property.shooting_height"
                        x-small
                        class="ma-1"
                      >
                        {{ item.property.shooting_height }}m
                      </v-chip>
                      <v-chip
                        v-if="item.property.gimbal_angle"
                        x-small
                        class="ma-1"
                      >
                        {{ item.property.gimbal_angle }}°
                      </v-chip>
                      <v-chip
                        v-if="item.property.drone_type"
                        x-small
                        class="ma-1"
                      >
                        {{ item.property.drone_type }}
                      </v-chip>
                      <v-chip
                        v-if="
                          item.color_type == 'color' ||
                          item.color_type_count == 2
                        "
                        color="green"
                        x-small
                        class="ma-1"
                      >
                        可視
                      </v-chip>
                      <v-chip
                        v-if="
                          item.color_type == 'thermal' ||
                          item.color_type_count == 2
                        "
                        color="orange"
                        x-small
                        class="ma-1"
                      >
                        サーモ
                      </v-chip>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn depressed @click.native="close()">キャンセル</v-btn>
          <v-btn
            depressed
            @click.native="onCopy()"
            color="primary"
            :disabled="selectedIndex == undefined"
            >コピー</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- コピー確認ダイアログ -->
    <v-dialog v-model="showConfirmDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">コピー確認</v-card-title>
        <v-card-text v-if="showConfirmDialog">
          <p>
            <b>コピー元：</b>{{ this.sourceFolder.property.shooting_date ? this.sourceFolder.property.shooting_date.split(' ')[0] : null }}{{ this.sourceFolder.note ? ' (' + this.sourceFolder.note + ')' : null }}
          </p>
          <p>
            <b>コピー先：</b>{{ this.destinationFolder.property.shooting_date ? this.destinationFolder.property.shooting_date.split(' ')[0] : null }}{{ this.destinationFolder.note ? ' (' + this.destinationFolder.note + ')' : null }}
          </p>
          <p v-if="canCopyByAdd">
            <b>
              コピー先には、アノテーションデータは既に登録されています。<br />
              置き換えるか追加でコピーするか選択してください。
            </b>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="showConfirmDialog = false">キャンセル</v-btn>
          <v-btn depressed color="primary" @click="copy('replace')">{{
            canCopyByAdd ? "置き換える" : "コピー"
          }}</v-btn>
          <v-btn
            v-if="canCopyByAdd"
            depressed
            color="primary"
            @click="copy('add')"
            >追加でコピー</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { store } from "@/store";

export default {
  name: "AnnotationCopyDialog",
  props: ["value"],
  data() {
    return {
      mapviewState: store.state.mapview,
      showConfirmDialog: false,
      selectedIndex: undefined,
      sourceFolder: undefined,
      destinationFolder: undefined,
      canCopyByAdd: false,
      folders: [],
    };
  },
  methods: {
    getFolders() {
      this.sourceFolder = undefined;
      this.destinationFolder = undefined;
      this.selectedIndex = undefined;
      this.folders = [];
      this.axios
        .get(`/api/folder/get-folder-list/${this.mapviewState.folderId}`)
        .then((response) => {
          const folders = response.data;
          folders.forEach((folder) => {
            if (folder.property.shooting_height) {
              folder.property.shooting_height = folder.property.shooting_height.toString();
              folder.property.shooting_height = folder.property.shooting_height.split(
                "M"
              )[0];
            }
            if (folder.id != this.mapviewState.folderId) {
              this.folders.push(folder);
            } else {
              this.sourceFolder = folder;
            }
          });
        });
    },
    onCopy() {
      this.canCopyByAdd = false;
      this.destinationFolder = this.folders[this.selectedIndex];
      this.axios
        .get("/api/annotation/" + this.destinationFolder.id)
        .then((response) => {
          const list = response.data.annotation.panel_abnormality.list;
          this.canCopyByAdd = list && list.length > 0;
          this.showConfirmDialog = true;
        });
    },
    copy(copyType) {
      const body = {
        sourceId: this.sourceFolder.id,
        destinationId: this.destinationFolder.id,
        copyType: copyType,
      }
      this.axios
        .post("/api/annotation/copy", body)
        .then(() => {
          this.$emit("copied", this.destinationFolder.id);
          this.close();
        })
        .catch(() => {
          store.showErrorDialog("エラーが発生しました。再度試してください。");
          this.close();
        });
    },
    close() {
      this.showConfirmDialog = false;
      this.$emit("input");
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.getFolders();
      }
    },
  },
};
</script>

<style>
#folderSelector {
  overflow-y: auto;
  max-height: calc(100vh - 250px);
}
#folderSelector .v-list-item:not(:last-child) {
  border-bottom: 1px solid #ccc;
}
</style>
